var render = function render(){var _vm=this,_c=_vm._self._c;return _c('woot-modal',_vm._g(_vm._b({attrs:{"show":_vm.show,"on-close":_vm.onClose,"size":_vm.sizeClass}},'woot-modal',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }